import { styled } from '@mui/material'
import { blackToTransparentGradient } from '$setup/style/helpers.ts'

export const CreateStoryFooter = styled('div')`
  display: flex;
  width: 100%;
  padding: 16px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  height: 80px;
  position: relative;
  margin-top: auto;
  z-index: 1;
  background: ${blackToTransparentGradient('top')};
`
